import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

declare global {
  interface Window {
    KTApp?: {
      init: () => void;
    };
  }
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .then(() => {
    if (window.KTApp?.init) {
      window.KTApp.init(); // Safe and typed
    }
  })
  .catch(err => console.error(err));